export default "__VITE_ASSET__DZFQRIpx__"